import { track } from "~/modules/analytics/track";
import { DataGridUserEvents } from "~/modules/analytics/events/dataGrid";
import { SortDirection, SortDirections } from "~/modules/filters/types";
import debounce from "lodash.debounce";

// // // //

/**
 * trackDataGridSort
 * Tracks the event when a user sorts the DataGrid component
 */
export function trackDataGridSort(props: {
    direction: SortDirections | SortDirection;
    column: string;
    tableName: string;
}) {
    track(DataGridUserEvents.Sort, props);
}

/**
 * trackPageChange
 * Tracks the event when a user changes the pagination in the DataGrid component
 */
export function trackPageChange(props: {
    page: number;
    perPage: number;
    tableName: string;
}) {
    track(DataGridUserEvents.ChangePage, props);
}

/**
 * trackScroll
 * Tracks the event when a user scrolls table using the HorizontalScrollbar component
 * NOTE - we debounce this to prevent self-spamming our analytics backend
 */
const trackScrollDebounced = debounce((props: { tableName: string }) => {
    track(DataGridUserEvents.Scrollbar, props);
}, 1000);
export function trackScroll(props: { tableName: string }) {
    trackScrollDebounced(props);
}

/**
 * trackClickScrollButton
 * Tracks the event when a user clicks the "Scroll to front / Scroll to back" button
 */
export function trackClickScrollButton(props: { direction: "front" | "end" }) {
    track(DataGridUserEvents.ClickScrollButton, props);
}
